import { createMicroservice } from '../../helpers/auto-import'

const files = require.context('.', false, /\.js$/);
export default createMicroservice(files);